import React from 'react';
import PropTypes from 'prop-types';

export default function ExpandableFormListItem({
    headline,
    subHeadline,
    subtext,
    editable = false,
    deletable = false,
    onDelete,
    summaryItems,
    emailAddress,
    form,
    branchStatusChip,
    ...rest
}) {

    const handleDeleteKeyDown = (event) => {
    };

    return (
        <li {...rest}>
            <div className="expandable-form-headline">
                <div className={`left-side ${!!subtext && "left-with-subtext"}`}>
                    <h4 className="h4">
                        {headline}
                        {subHeadline && (
                            <p>
                                {subHeadline}
                            </p>
                        )}
                    </h4>
                    {subtext && (
                        <p>{subtext}</p>
                    )}
                    {branchStatusChip &&
                        <div className={`chips ${branchStatusChip === 'INActive' ? 'chips-neutral' : 'chips-success'}`}>{branchStatusChip}</div>
                    }
                </div>
                <div className="right-side">
                    {deletable && (
                        <button
                            type="button"
                            className="expandable-form-control expandable-form-delete-icon geico-icon--small geico-icon--actionable geico-icon icon-trash"
                            onClick={onDelete}
                            onKeyDown={handleDeleteKeyDown}
                            aria-label="Delete item"
                            tabIndex={0}
                        />
                    )}
                    {editable && (
                        <button
                            type="button"
                            className="expandable-form-control expandable-form-edit-icon geico-icon--small geico-icon--actionable geico-icon icon-edit"
                            aria-label="Edit item"
                        />
                    )}
                </div>
            </div>
            {summaryItems && (
                <ul className="list list--two-column short-value expandable-form-summary-list">
                    {summaryItems.map((item) =>
                        <li key={item.name} >
                            <div>{item.name}</div>
                            <div>{item.value}</div>
                        </li>
                    )}
                </ul>
            )}
            {emailAddress && (
                <ul className="expandable-form-summary-list email-address-summary">
                    <li>
                        <div>{emailAddress}</div>
                    </li>
                </ul>
            )}
            <div className="expandable-form-content-container">
                {form}
            </div>
        </li>
    );
};

ExpandableFormListItem.propTypes = {
    headline: PropTypes.string,
    subHeadline: PropTypes.string,
    subtext: PropTypes.string,
    editable: PropTypes.bool,
    deletable: PropTypes.bool,
    onDelete: PropTypes.func,
    summaryItems: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    })),
    emailAddress: PropTypes.string,
    form: PropTypes.node,
    branchStatusChip: PropTypes.string
};
